<template>
    <NavComponents/>
  <div class="container">
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="card p-4">
          <h2 class="card-title text-center mb-4">欢迎注册</h2>
            <div class="mb-3">
                <input type="text" class="form-control" id="userName" placeholder="用户名" v-model="userName" @blur="checkUserName" :style="{ border: userNameFlag ? '' : '1px solid red' }" required>
            </div>
            <div class="mb-3">
              <input type="text" class="form-control" id="nickName" placeholder="昵称" v-model="nickName" @blur="checkNickName" :style="{ border: nickNameFlag ? '' : '1px solid red' }" required>
            </div>
            <div class="mb-3">
              <input type="password" class="form-control" id="password" placeholder="密码" v-model="password" @blur="checkPassword" :style="{ border: passwordFlag ? '' : '1px solid red' }" required>
            </div>
            <div class="mb-3">
              <input type="password" class="form-control" id="rightPassword" placeholder="确认密码" v-model="rightPassword" @blur="checkRightPassword" :style="{ border: rightPasswordFlag ? '' : '1px solid red' }" required>
            </div>
            <div class="mb-3">
              <input type="email" class="form-control" id="email" placeholder="邮箱" @blur="checkEmail" :style="{ border: emailFlag ? '' : '1px solid red' }" v-model="email" required>
              <input type="text" class="form-control" id="code" placeholder="验证码" v-model="code" @blur="checkCode" :style="{ border: codeFlag ? '' : '1px solid red' }" style="width: 50%; display: inline; margin-top: 10px; margin-right: 10%" required>
              <button class="btn btn-secondary btn-block" @click="sendEmail" style="margin-top: 5px" :disabled="countingDown"> 
                {{ buttonText }}
              </button>
            </div>
            
            <div class="mb-3">
              <CityComponent @dataCity='getCity' @blur="checkCity"/>
            </div>
            

            <div class="mb-3">
                <select class="form-select" id="gender" name="gender" v-model="gender">
                <option value="0" selected>男</option>
                <option value="1">女</option>
                <option value="2">保密</option>
                </select>
            </div>
            <div class="text-center">
                <button class="btn btn-success btn-block" style="margin-right: 20px;">
                <router-link class="nav-link" :to="{ name: 'login' }" style="color: white">
                  ←登 录
                </router-link>
              </button>
              
                <button class="btn btn-primary btn-block" @click="register">注 册</button>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
  
<script setup>
import { ref, computed, watch } from "vue";
import $ from 'jquery';
import { ElMessage } from "element-plus";
import router from '@/router/index'
import CityComponent from '@/components/data/CityComponent.vue'
import NavComponents from '@/components/nav/NavComponents.vue'

const userName = ref("");
const password = ref("");
const rightPassword = ref("");
const nickName = ref("");
const email = ref("");
const code = ref("");
const gender = ref(0);
const city = ref("");
const countingDown = ref(false);
const count = ref(60);

// 用户名正则表达式
const userNameReg = /^[a-zA-Z0-9_]{5,12}$/;
const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
let userNameFlag = true;
let nickNameFlag = true;
let passwordFlag = true;
let rightPasswordFlag = true;
let emailFlag = true;
let codeFlag = true;
let cityFlag = true;

const buttonText = computed(() => {
  return countingDown.value ? `${count.value} 秒后重试` : `发送验证码`;
});

const sendEmail = () => {
  if(email.value == "") {
    ElMessage({
      type: "error",
      message: "请输入邮箱",
    });
    return;
  }

  if (! checkEmail()) {
    console.log(countingDown.value);
    return ;
  }

  // 禁用发送验证码按钮
  countingDown.value = true;
  console.log(countingDown.value);

  $.ajax({
    url: "http://124.222.105.205:5000/visitor/api/mail/sendMail",
    type: "post",
    data: {
      email: email.value,
    },
    contentType: "application/json;charset=utf-8",
    success(resp) {
      if (resp.code === "200") {
        ElMessage({
          type: "success",
          message: resp.msg,
        });
      } else {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }
    },
    error() {
      // 发送邮件失败时，将 countingDown 设置为 false
      countingDown.value = false;
    }
  });
};

watch(countingDown, (value) => {
  if (value) {
    const timer = setInterval(() => {
      count.value--;
      if (count.value <= 0) {
        clearInterval(timer);
        countingDown.value = false;
        count.value = 60;
      }
    }, 1000);
  }
});

// 验证用户名
const checkUserName = () => {
    if (userNameReg.test(userName.value)) {
        // 正则验证成功
        // 查询是否该用户名存在
        $.ajax({
                url: "http://124.222.105.205:5000/get/user/hasUesrByUserName",
                type: "post",
                data:{
                    userName: userName.value,
                },
                success(resp) {
                    if (resp.code === "417") {
                        changeStatus("userName", true);
                        userNameFlag = true;
                        return true;
                        
                    } else if (resp.code == "200"){
                        ElMessage({
                            type: "error",
                            message: "该用户名已存在",
                        });
                        changeStatus("userName", false);
                        userNameFlag = false;
                        return false;
                    } else {
                        changeStatus("userName", false);
                        userNameFlag = false;
                        return false;
                    }
                },
                error() {
                    changeStatus("userName", false);
                    userNameFlag = false;
                    return false;
                }
            });
    } else {
        // 正则验证失败
        changeStatus("userName", false);
        ElMessage({
                type: "error",
                message: "请输入5~12的数字, 字母, 以及 _ 下划线",
            });
            userNameFlag = false;
            return false;
            
    }
}

// 验证昵称
const checkNickName = () => {
    console.log(nickName.value);
    if (nickName.value != '' && nickName.value.length < 20) {
        // 正则验证成功
        changeStatus("nickName", true);
        nickNameFlag = true;
        return true;
    } 
    
    // 正则验证失败
    ElMessage({
        type: "error",
        message: "昵称只能为1~20个字",
    });
    changeStatus("nickName", false);
    nickNameFlag = false;
    return false;
}

// 验证密码
const checkPassword = () => {
    if (password.value != '' || password.value.length > 6) {
        // 正则验证成功
        changeStatus("password", true);
        passwordFlag = true;
        return true;
    } 
    
    // 正则验证失败
    changeStatus("password", false);
    ElMessage({
        type: "error",
        message: "密码至少6位",
    });
    passwordFlag = false;
    return false;
}

// 验证确认密码
const checkRightPassword = () => {
    if (rightPassword.value == password.value && password.value != '') {
        // 正则验证成功
        changeStatus("rightPassword", true);
        rightPasswordFlag = true;
        return true;
    } 
    
    // 正则验证失败
    changeStatus("rightPassword", false);
    ElMessage({
        type: "error",
        message: "两次密码不一致",
    });
    rightPasswordFlag = false;
    return false;
}

// 验证邮箱
const checkEmail = () => {
    if (emailRegex.test(email.value)) {
        // 正则验证成功
        $.ajax({
                url: "http://124.222.105.205:5000/get/user/hasUesrByEmail",
                type: "post",
                data:{
                    email: email.value,
                },
                success(resp) {
                    if (resp.code === "417") {
                        changeStatus("email", true);
                        emailFlag = true;
                        
                    } else if (resp.code == "200"){
                        ElMessage({
                            type: "error",
                            message: "该邮箱已存在",
                        });
                        changeStatus("email", false);
                        emailFlag = false;
                    } else {
                        changeStatus("email", false);
                        emailFlag = false;

                    }
                },
                error() {
                    changeStatus("email", false);
                    emailFlag = false;
                }
            });
            return emailFlag;
    } else{
    // 正则验证失败
    changeStatus("email", false);
        ElMessage({
            type: "error",
            message: "邮箱格式错误",
        });
        emailFlag = false;
        return false;
    }
    
   
}

// 验证验证码
const checkCode = () => {
    if (code.value != '') {
        // 正则验证成功
        changeStatus("code", true);
        codeFlag = true;
        return true;
    } 
    
    // 正则验证失败
    changeStatus("code", false);
    ElMessage({
        type: "error",
        message: "请输入验证码",
    });
    codeFlag = false;
    return false;
}

// 验证城市
const checkCity = () => {
  if(city.value == '') {
    cityFlag = false;
    ElMessage({
        type: "error",
        message: "请选择城市",
    });
    return false;
  }
  cityFlag = true;
  return true;
}

// 改变input框
const changeStatus = (name, status) => {
  if (status) {
    // 改变为空
    $("#" + name).css("border", "1px solid green"); // 清空边框样式
  } else {
    // 改变为红色实线边框
    $("#" + name).css("border", "1px solid red");
  }
}

const getCity = (adCode) => {
  city.value = adCode;
  console.log(adCode);
}

// 注册逻辑
const register = () => {
    checkUserName();
    checkNickName();
    checkPassword();
    checkRightPassword();
    checkEmail();
    checkCode();
    checkCity();
    if ( userNameFlag && nickNameFlag  && passwordFlag && rightPasswordFlag  && emailFlag && codeFlag && cityFlag) {
        // 校验验证码是否正确
        $.ajax({
                url: "http://124.222.105.205:5000/get/user/judgeCode",
                type: "post",
                data:{
                    email: email.value,
                    code: code.value,
                },
                success(resp) {
                    if (resp.code === "200") {
                        // 添加用户
                        $.ajax({
                            url: "http://124.222.105.205:5000/get/user/register",
                            type: "post",
                            data: JSON.stringify({
                                userName: userName.value,
                                nickName: nickName.value,
                                password: password.value,
                                email: email.value,
                                gender: gender.value,
                                city: city.value
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            },
                            success(resp) {
                                if (resp.code === "200") {
                                    ElMessage({
                                        type: "success",
                                        message: "注册成功, 请登录!",
                                    });
                                    router.push({name: "login"});
                                    
                                } else {
                                    ElMessage({
                                        type: "error",
                                        message: "注册失败!",
                                    });
                                }
                            },
                            error() {
                                ElMessage({
                                    type: "error",
                                    message: "注册失败!",
                                });
                            }
                        });
                        return true; 

                    } else {
                        ElMessage({
                            type: "error",
                            message: "验证码错误",
                        });
                        changeStatus("code", false);
                        return false;
                    }
                }
            });
    }
}
</script>

<style scoped>

    .card {
      border: none;
      border-radius: 10px;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    }
    .card-title {
      color: #007bff;
    }
    .btn-primary {
      background-color: #007bff;
      border: none;
    }
    .btn-primary:hover {
      background-color: #0056b3;
    }
</style>